import React  from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { useSelector } from 'react-redux';
import { AUTHENTICATED_ENTRY, SUPPORT_HELP_PUBLIC_PATH } from 'configs/AppConfig'


const unRestructesRoutes= ["/","/pricing",SUPPORT_HELP_PUBLIC_PATH,"/app/about","/app/contact","/app/help","/health","/auth/login","/login","/signup","/auth/register-1","/auth/login-1","/auth/login-2","/auth/forgot-password","/auth/reset-password","/user-reset-password","/forget-reset-password","/payment/success","/payment/cancel","/payment/status","/payment/debug","/payment/test-route","/payment/direct-test"]

const PublicRoute = ({ children }) => {

	const { token } = useSelector(state => state.auth)
	const location = useLocation();

	if(unRestructesRoutes.includes(location.pathname.toLowerCase())){
		return children;
	}

	return token ? <Navigate to={AUTHENTICATED_ENTRY} /> : children

}

export default PublicRoute